export default {
  common: {
    login: '로그인',
    logout: '로그아웃',
    submit: '제출',
    cancel: '취소',
    confirm: '확인',
    save: '저장',
  },
  login: {
    title: '로그인',
    email: '이메일',
    password: '비밀번호',
    remember: '로그인 상태 유지',
    forgot: '비밀번호를 잊으셨나요?',
    error: '이메일 또는 비밀번호가 잘못되었습니다',
    subtitle: '자동 퀀트 트레이딩 시스템',
    telegramLogin: 'Telegram으로 로그인',
  },
  nav: {
    dashboard: '대시보드',
    trading: '거래',
    settings: '설정',
    message: '메시지'
  },
  dashboard: {
    title: '대시보드',
    totalAssets: '총 자산',
    dailyPnL: '일일 손익',
    activeStrategies: '활성 전략',
    recentTrades: '최근 거래',
    running: '실행 중',
    paused: '일시 중지',
    timeAgo: '{time}분 전'
  },
  trading: {
    title: '거래 관리',
    strategyConfig: '전략 설정',
    positions: '포지션',
    selectPair: '거래쌍 선택',
    pleaseSelect: '선택하세요',
    strategyType: '전략 유형',
    conservative: '보수적',
    aggressive: '공격적',
    investAmount: '투자 금액',
    enterAmount: '금액 입력',
    startStrategy: '전략 시작',
    closePosition: '청산',
    conservativeStrategy: '보수적 전략',
    aggressiveStrategy: '공격적 전략',
    stopSchedule: '정지 예약',
    fillRequired: '모든 필수 항목을 입력하세요',
    strategyStarted: '전략이 시작되었습니다',
    closingPosition: '청산 중...',
    investMultiplier: '투자 배수',
    estimatedAmount: '예상 투자 금액: {min} ~ {max} USDT',
    positionAmount: '포지션 금액',
    profit: '이익',
    pair: {
      'BTC/USDT': '비트코인/USDT',
      'ETH/USDT': '이더리움/USDT',
      'BNB/USDT': '바이낸스 코인/USDT',
      'SOL/USDT': '솔라나/USDT'
    },
  },
  settings: {
    title: '설정',
    language: '언어',
    selectLanguage: '언어 선택',
    apiSettings: 'API 설정',
    apiKey: 'API 키',
    enterApiKey: 'API 키 입력',
    secretKey: '시크릿 키',
    enterSecretKey: '시크릿 키 입력',
    riskControl: '리스크 관리',
    maxTradeAmount: '최대 거래액',
    stopLoss: '손절률',
    notifications: '알림 설정',
    tradeNotification: '거래 알림',
    riskAlert: '리스크 경고',
    saved: '설정이 저장되었습니다',
    logoutTitle: '로그아웃 확인',
    logoutConfirm: '로그아웃하시겠습니까?',
    membership: '멤버십',
    trial: '체험판',
    basic: '베이직',
    pro: '프로',
    premium: '프리미엄',
    daysRemaining: '남은 기간 {days}일',
    startTrial: '체험 시작',
    trialStarted: '체험이 시작되었습니다',
    purchase: '구매하기',
    tradingPairs: '거래쌍 수',
    validPeriod: '유효기간',
    oneMonth: '1개월',
    unlimited: '무제한',
    paymentTitle: 'QR코드 결제',
    scanToPay: 'USDT-TRC20로 스캔해주세요',
  },
  message: {
    title: '메시지 센터',
    notifications: '알림',
    logs: '로그',
    success: '성공',
    warning: '경고',
    trade: '거래',
    system: '시스템',
    strategyStarted: '{pair} 전략 시작됨',
    profitTarget: '목표 수익 달성 {amount}',
    tradingLog: '{pair} {action} @ {price}',
    systemLog: '시스템 {action}'
  },
  // ... 其他翻譯
} 